<div class="grid__col-12 guts-p-t-3-half">
  <div class="l_flex l_flex-middle l_flex-justify">
    <h2 class="h2">{{ followerCountFormat }}</h2>
    <a
      *ngIf="reportsRouterLink"
      [routerLink]="reportsRouterLink"
      class="m-guts-m-t-1-half m-full-width"
      df-button
      dfButtonType="passive"
      data-dgat="pathway-followers-792"
      ><df-icon icon="arrow-down-tray" size="small"></df-icon>
      {{ 'OrgReportingCtrl_DownloadableReports' | translate }}</a
    >

  </div>
  <dgx-data-table
    componentWrapperClass="grid__col-12 grid__col--bleed guts-p-t-1-half"
    [columns]="columns"
    [hasNoResults]="hasNoResults"
    [items]="followers"
    [isLoading]="isLoading"
    [isDescending]="isDescending"
    [numResultsPerPage]="numResultsPerPage"
    [orderBy]="orderBy"
    [propTrackingKey]="'userProfileKey'"
    [totalNumResults]="totalFollowers"
    (pageChange)="onPageChange($event)"
    (updateSort)="onSort($event)"
  ></dgx-data-table>
</div>

<ng-template #completion let-item>
  {{ item.completionPercent }}%
  <df-icon
    icon="question-mark-circle"
    size="small"
    class="color-ebony-a45 guts-m-l-half"
    tabindex="0"
    role="text"
    [attr.aria-label]="item.completionTooltip"
    [ngbTooltip]="item.completionTooltip"
  ></df-icon>
</ng-template>
